import axios, { AxiosRequestConfig, AxiosError } from "axios";
import { Base64 } from "js-base64";
import Cookies from "js-cookie";
import { toast } from "react-toastify";

// 1. Ambil BASE_URL dari environment variable
const API_URL = process.env.REACT_APP_BASEURL;

// 2. Buat instance axios dengan baseURL yang sudah diatur
const api = axios.create({
  baseURL: API_URL,
});

// Definisikan tipe data untuk respons agar lebih konsisten
interface ApiResponse {
  code: number;
  error: boolean;
  message: string;
  data: any;
}

/**
 * Fungsi untuk memanggil endpoint publik (yang tidak memerlukan token).
 */
export async function callAPI(
  config: AxiosRequestConfig
): Promise<ApiResponse> {
  try {
    const response = await api(config);
    return {
      code: response.status,
      error: !response.data.status,
      message: response.data.message || "Success",
      data: response.data.data,
    };
  } catch (error) {
    const err = error as AxiosError<any>;
    console.error("API Call Error:", err);
    return {
      code: err.response?.status || 503,
      error: true,
      message: err.response?.data?.message || "Terjadi masalah pada jaringan.",
      data: null,
    };
  }
}

/**
 * Fungsi untuk memanggil endpoint yang memerlukan otentikasi (dengan token).
 */
export async function callAPIWhiteToken(
  config: AxiosRequestConfig
): Promise<ApiResponse> {
  const tokenBase64 = Cookies.get("token");

  if (!tokenBase64) {
    toast.error("Anda harus login untuk mengakses halaman ini.");
    return {
      code: 401, // Unauthorized
      error: true,
      message: "Token tidak ditemukan. Silakan login kembali.",
      data: null,
    };
  }

  const token = Base64.decode(tokenBase64);
  config.headers = {
    ...config.headers,
    Authorization: `Bearer ${token}`,
  };

  try {
    const response = await api(config);
    return {
      code: response.status,
      error: !response.data.status,
      message: response.data.message || "Success",
      data: response.data.data,
    };
  } catch (error) {
    const err = error as AxiosError<any>;
    console.error("Authenticated API Call Error:", err);

    if (err.response?.status === 401 || err.response?.status === 403) {
      toast.error("Sesi Anda telah berakhir. Silakan login kembali.");
    }

    return {
      code: err.response?.status || 503,
      error: true,
      message: err.response?.data?.message || "Terjadi sebuah kesalahan.",
      data: null,
    };
  }
}
